module.exports = __webpack_public_path__ + "img/news_01.94c4e5d0.jpg";